<template>
  <div class="news">
    <!--顶部轮播 -->
    <div class="swpier">
      <img :src="swiperImage" alt="">
      <!-- <breadcrumb></breadcrumb> -->
    </div>
    <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product-cont">
        <div class="product-box">
          <div class="news-box">
            <div class="news-list">
              <div class="news-list-item" v-for="(item, index) in list" :key="index">
                <div class="news-list-item-noe" v-if="index == 0" @click="getDetails(item)">
                  <div class="news-list-item-image">
                    <img :src="item.image" alt="">
                  </div>
                  <div class="news-list-item-right">
                    <div class="item-title">{{ item.title }}</div>
                    <div class="item-line"></div>
                    <div class="item-content"> {{ item.description }}</div>
                    <div class="item-bottom">
                      <div class="item-times">
                        <img src="../../../static/image/timesicon.png" alt="">
                        <span> {{ item.createtime }} </span>
                      </div>
                      <div class="item-right-button button-hover">
                        <img src="../../../static/image/jiantou.png" alt="">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="news-list-item-box" v-else @click="getDetails(item)">
                  <div class="news-list-item-y">
                    <div class="item-left">
                      <div class="item-times">
                        <p class="item-day">{{ item.day }}</p>
                        <p class=" item-year">{{ item.year }}/{{ item.math }}</p>
                      </div>
                      <div class="item-title">
                        {{ item.title }}
                      </div>
                    </div>
                    <div class="item-right">
                      {{ item.description }}
                    </div>
                  </div>
                  <div class="item-button button-hover">
                    <i class="el-icon-top-right" color="#FFFFFF"></i> More
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product">
      <div class="product-cont">
        <div class="product-box">
          <div class="block pagination">
            <el-pagination background layout="total, prev, pager, next, jumper" :page-size="pageSize" :total="total"
              @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <footerBotom></footerBotom>
  </div>
</template>
<script >
import { newsList, nav } from '@/request/api'
import footerBotom from '@/components/footer.vue'
export default {
  components: {
    footerBotom
  },
  data() {
    return {
      list: [],
      total: 100,
      pageSize: 10,
      page: 1,
      swiperImage: ""
    }
  },
  created() {
    this.getList()
    this.getNav()
  },
  methods: {
    getNav() {
      nav({}).then(res => {
        this.swiperImage = res.data[4].image
      })
    },
    getList() {
      newsList({
        pageSize: this.pageSize,
        page: this.page
      }).then(res => {
        if (res.code == 1) {
          this.total = res.data.total
          res.data.list.forEach(function (item) {
            let times = item.createtime.split('-')
            item.day = times[2]
            item.math = times[1]
            item.year = times[0]
          })
          this.list = res.data.list
        }
      })
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },
    getDetails(item) {
      this.$router.push({
        path: '/newsDetails',
        query: {
          productId: item.id,
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.swpier {
  margin-top: 90px;
  width: 100%;
  height: auto;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }
}

.news-box {

  .news-list {
    .news-list-item-noe {
      display: flex;
      cursor: pointer;
      align-items: stretch;

      .news-list-item-image {
        width: 53%;

        img {
          width: 100%;
          height: auto;
          vertical-align: bottom;
        }
      }

      .item-title {
        font-size: 26px;
        width: 100%;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #333333;
      }

      .item-line {
        margin-top: 18px;
        width: 50px;
        height: 2px;

        background: #DB2733;
      }

      .item-content {
        margin-top: 18px;
        font-size: 16px;
        width: 100%;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        overflow: hidden;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /*! autoprefixer: on */
        word-break: break-all;
        color: #666666;
        line-height: 30px;
      }

      .item-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 36px;

        .item-times {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-family: PingFang SC-Regular, PingFang SC;
          color: #333333;

          span {
            margin-left: 10px;
          }
        }
      }

      .item-time {
        font-size: 18px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: #333333;
      }
    }

    .news-list-item-right {
      max-width: 47%;
      background: #F7F7F7;
      padding: 41px 48px;

      .item-right-button {
        cursor: pointer;
      }
    }

    .news-list-item-box {
      cursor: pointer;
      padding: 58px 0;
      border-bottom: 1px solid #D6D6D6;

      .news-list-item-y {
        display: flex;
        justify-content: space-between;

        .item-left {
          display: flex;
          align-items: center;

          .item-title {
            margin-left: 19px;
            font-size: 26px;

            color: #333333;
            line-height: 39px;
          }

          .item-day {
            font-size: 59px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            color: #333333;
          }

          .item-year {
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            color: #333333;
          }
        }

        .item-right {
          width: 50%;
          font-size: 16px;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          overflow: hidden;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /*! autoprefixer: on */
          word-break: break-all;
          color: #666666;
          line-height: 30px;
        }

      }

      .item-button {
        margin-left: 90px;
        margin-top: 21px;
        cursor: pointer;
        width: 136px;
        height: 43px;
        text-align: center;
        line-height: 43px;
        border-radius: 22px;
        border: 1px solid #707070;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: #333333;
      }
    }

    .news-list-item-box:hover {
      border-bottom: 1px solid #DB2733;

      .item-day {
        color: #DB2733 !important;
      }

      .item-button {
        border: 1px solid #DB2733;
        background: #DB2733;
        color: #FFFF;

      }
    }
  }

}

.pagination {
  display: flex;
  justify-content: center;

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #DB2733;
    color: #FFFF !important;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #DB2733;
  }

  /deep/ .el-input__inner:focus {
    border-color: #DB2733 !important;
  }
}

@media screen and (max-width:767px) {
  .news-list {
    .news-list-item-noe {
      display: block !important;

      .news-list-item-image {

        width: 100% !important;
      }
    }

    .news-list-item-right {
      padding: 30px;
      max-width: calc(100% - 60px) !important;
      width: calc(100% - 60px) !important;
    }

    .news-list-item-y {
      display: block !important;

      .item-right {
        margin-top: 30px;
        width: 100% !important;
      }

    }

    .item-button {
      margin: 0 auto !important;
      margin-top: 30px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/news/news.vue